import { UniFiCategoryId, UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/WiFi/u7-pro-max@2x.jpg";
import v3Image from "../../assets/Flagship/u7-pro-max.jpg";
import type { Product } from "../../types";
import { wifiFlagship } from "../product-list-groups/wifi-flagship";
import {
  connectedDevices,
  dimensions,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiTechnology,
} from "../properties";

export const u7proMax: Product = {
  id: "u7proMax",
  productTitle: "U7 Pro Max",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.WiFi}/u7-pro-max`,
  ],
  storePathParts: {
    productSlug: "u7-pro-max",
    category: UniFiChildCategorySlug.WiFiFlagship,
  },
  sku: "U7-Pro-Max",
  description: "u7proMax.description.1",
  image: { src: image, width: 200, height: 160 },
  v3Image: {
    src: v3Image,
    width: 207,
    height: 182,
  },
  productListGroup: wifiFlagship,
  propertyValues: [
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u7proMax.wifiTechnology",
      },
    },
    {
      propertyId: dimensions.id,
      value: {
        type: "translation",
        value: "u7proMax.dimensions",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "160 m² (1,750 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "500+" },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE+" },
    },
    {
      propertyId: uplink.id,
      value: { type: "string", value: "2.5/1 GbE" },
    },
    {
      propertyId: "radios",
      value: { type: "boolean", value: true },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "wifiMounting",
      value: {
        type: "translation",
        value: "commons.mounting.ceilingWall",
      },
    },
  ],
};
